<template>
  <sl-content 
    pagetype="2" 
    pagename="slinfrastructurecybersecurity"
    :title="$t('sl.infrastructure.title') "
    titlecolor="lightgreen"
  />
</template>

<script>
import Vue from 'vue';
import SlContent from '@/views/Layout/SlContent';

  export default {
    name: 'infrastructure-cybersecurity',
   
    components: {
      SlContent
    },
     data() {
      return {
        
      };
    },
  };
</script>

